export const blockIconsAudioandvideoViewInArNew = (
	<span className='material-symbols-outlined'>view_in_ar</span>
);
